<template>
  <a-spin :spinning="loading" class="list-wrapper">
    <div class="c-box spin-content">
      <a-row type="flex" justify="space-between" class="mb-16">
        <h2>Umowy</h2>
        <label>
          <input
            ref="uploadInput"
            type="file"
            id="file"
            @change="uploadAgreement"
            class="input-file"
          />
          <a-button
            type="primary"
            icon="upload"
            @click="handleUploadButtonClick"
          >
            Załącz umowę
          </a-button>
        </label>
      </a-row>
      <a-empty v-if="!loading && items.length === 0" description="Brak umów" />
      <div v-for="item in items" :key="item.id" class="item mb-16">
        <a-row type="flex" justify="space-between" align="middle">
          <a :href="item.file" target="_blank" class="item__main">
            <a-icon type="paper-clip" class="item__icon" />

            <div>
              <h3 class="item__title">{{ item.file_name }}</h3>
              <span class="t-secondary-text">
                {{ getDateAndTime(item.created) }}
              </span>
            </div>
          </a>

          <a-button
            v-if="canRemove(item)"
            class="c-remove-button"
            type="link"
            icon="delete"
            @click="confirmRemoveAgreement(item)"
          />
        </a-row>
      </div>
    </div>
  </a-spin>
</template>

<script>
import { Agreement } from '@/api'

export default {
  props: {
    userId: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      items: [],
      loading: false
    }
  },
  mounted() {
    this.fetchAgreements()
  },
  methods: {
    confirmRemoveAgreement(item) {
      this.$confirm({
        title: 'Usuń umowę',
        maskClosable: true,
        content: 'Czy na pewno chcesz usunąć dokument?',
        okText: 'Usuń',
        cancelText: 'Anuluj',
        onOk: () => {
          this.removeAgreement(item)
        }
      })
    },
    fetchAgreements() {
      this.loading = true
      const params = {
        page_size: 'max',
        related_user: this.userId
      }
      Agreement.fetch({}, { params })
        .then(res => {
          this.items = res.data.results
        })
        .finally(() => {
          this.loading = false
        })
    },
    canRemove(item) {
      return this.isAdmin || this.userInfo.id === item.author
    },
    uploadAgreement(event) {
      const file = event.target.files[0]
      Agreement.postMultipart({
        file: file,
        related_user: this.userId
      }).then(() => {
        this.$notification.success({
          message: 'Wgrano umowę'
        })
        this.fetchAgreements()
      })
    },
    removeAgreement(instance) {
      Agreement.delete(instance.id).then(() => {
        this.$notification.success({
          message: 'Usunięto umowę'
        })
        this.fetchAgreements()
      })
    },
    handleUploadButtonClick() {
      this.$refs.uploadInput.click()
    }
  }
}
</script>

<style lang="scss" scoped>
.input-file {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.list-wrapper {
  margin-top: 40px;
}

.item {
  width: 100%;
  padding: 16px;
  background-color: rgba(black, 0.03);
  border-radius: 12px;

  &:last-child {
    margin-bottom: 0;
  }

  &__main {
    display: flex;
    align-items: center;
  }

  &__title {
    margin-bottom: 0;
  }

  &__icon {
    font-size: 24px;
    margin-right: 14px;
  }
}
</style>
